import React, { useRef, useState } from 'react';
import { Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import { useAppDispatch } from '../../app/hooks';
import { upddatePasswordAsync } from '../../slices/profile.slice';
import { addToast } from '../../slices/responseNotification.slice';

export interface UpdatePassword {
  username: string;
  currentPassword: string | undefined;
  newPassword: string | undefined;
}

const PasswordTab = () => {

  const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;

  const currentPassRef = useRef<HTMLInputElement>(null);
  const newPassRef = useRef<HTMLInputElement>(null);
  const newConfPassRef = useRef<HTMLInputElement>(null);

  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showNewConfPass, setShowNewConfPass] = useState(false);
  //const [isValidCurrentPass, setValidCurrentPass] = useState(false);
  const [isValidNewPass, setValidNewPass] = useState(false);
  const [isValidNewConfPass, setValidNewConfPass] = useState(false);
  //const [hasTochedCurrentPass, setHasTochedCurrentPass] = useState(false);
  const [hasTochedNewPass, setHasTochedNewPass] = useState(false);
  const [hasTochedNewConfPass, setHasTochedNewConfPass] = useState(false);

  const validatePassword = (password: string): boolean => {
    return PASSWORD_REGEX.test(password);
  }

  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    // create request
    const auth = JSON.parse(localStorage.getItem('auth')!);
    const updatePassword: UpdatePassword = {
      username: auth?.emailAddress,
      currentPassword: currentPassRef.current?.value,
      newPassword: newPassRef.current?.value,
    }
    const response = await dispatch(upddatePasswordAsync(updatePassword));
    const status: number = JSON.parse(JSON.stringify(response.payload));
    if (status === 204) {
      dispatch(addToast({
        id: Date.now(),
        type: 'success',
        message: 'Successfully changed the password'
      }))
    } else {
      dispatch(addToast({
        id: Date.now(),
        type: 'danger',
        message: 'Error occurred while changing the password'
      }))
    }
    // resetting the state values
    if (currentPassRef.current?.value) {
      currentPassRef.current.value = '';
    }
    if (newPassRef.current?.value) {
      newPassRef.current.value = '';
    }
    if (newConfPassRef.current?.value) {
      newConfPassRef.current.value = '';
    }
    setShowCurrentPass(false);
    setShowNewPass(false);
    setShowNewConfPass(false);
    //setValidCurrentPass(false);
    setValidNewPass(false);
    setValidNewConfPass(false);
    //setHasTochedCurrentPass(false);
    setHasTochedNewPass(false);
    setHasTochedNewConfPass(false);
  }

  const onChangeNewPassword = (e: any) => {
    setValidNewPass(validatePassword(e.target.value));
    if (newConfPassRef.current && newConfPassRef.current?.value !== '') {
      setValidNewConfPass(newPassRef.current?.value === newConfPassRef.current?.value)
    }
  }


  return (
    <div>
      <Row>
        <Col>
          <Form>
            <Form.Group className="mb-3" controlId="currentPassword">
              <Form.Label>Current Password</Form.Label>
              <Row>
                <Col md="8">
                  <InputGroup>
                    <Form.Control
                      ref={currentPassRef}
                      type={showCurrentPass ? 'text' : 'password'}
                    />
                    <InputGroup.Text>
                      <span
                        className='passVisible'
                        onClick={() => setShowCurrentPass(!showCurrentPass)}>
                        <i className={showCurrentPass ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'}>
                        </i>
                      </span>
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3" controlId="newPassword">
              <Form.Label>New Password</Form.Label>
              {
                (!isValidNewPass && hasTochedNewPass) ?
                  <Row>
                    <Col md="8">
                      <Form.Text>Use at least 8 characters, including upper and lower-case letters, numbers and special characters !@#$%^&*()</Form.Text>
                    </Col>
                  </Row> : <></>
              }
              <Row>
                <Col md="8">
                  <InputGroup>
                    <Form.Control
                      ref={newPassRef}
                      isValid={isValidNewPass}
                      isInvalid={!isValidNewPass && hasTochedNewPass}
                      type={showNewPass ? 'text' : 'password'}
                      onChange={(e) => onChangeNewPassword(e)}
                      onBlur={(e) => setHasTochedNewPass(true)}
                    />
                    <InputGroup.Text>
                      <span
                        className='passVisible'
                        onClick={() => setShowNewPass(!showNewPass)}>
                        <i className={showNewPass ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'}>
                        </i>
                      </span>
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3" controlId="newConfPassword">
              <Form.Label>Confirm New Password</Form.Label>
              {
                (!isValidNewConfPass && hasTochedNewConfPass) ?
                  <Row>
                    <Col md="8">
                      <Form.Text>Confirm password should be equal to new password</Form.Text>
                    </Col>
                  </Row> : <></>
              }
              <Row>
                <Col md="8">
                  <InputGroup>
                    <Form.Control
                      ref={newConfPassRef}
                      isValid={isValidNewConfPass}
                      isInvalid={!isValidNewConfPass && hasTochedNewConfPass}
                      type={showNewConfPass ? 'text' : 'password'}
                      onChange={(e) => setValidNewConfPass(newPassRef.current?.value === newConfPassRef.current?.value)}
                      onBlur={(e) => setHasTochedNewConfPass(true)}
                    />
                    <InputGroup.Text>
                      <span
                        className='passVisible'
                        onClick={() => setShowNewConfPass(!showNewConfPass)}>
                        <i className={showNewConfPass ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'}>
                        </i>
                      </span>
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mt-5">
              <Button
                disabled={!isValidNewPass || !isValidNewConfPass}
                onClick={() => handleSubmit()}
              >Save</Button>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default PasswordTab;
